import { Box, DialogTitle, Divider } from "@mui/material";
import type { ReactNode } from "react";
import { forwardRef } from "react";


type StandardDialogTitleProps = {
  variant?: "left" | "center";
  title: ReactNode;
  isSmallScreen: boolean;
  parentIsItemDetail?: boolean;
  onClose?: () => void;
};
const StandardDialogTitle = forwardRef<HTMLElement, StandardDialogTitleProps>(
  ({ variant = "left", title, isSmallScreen }, ref) => {
    return isSmallScreen ? (
      <DialogTitle ref={ref}>
        <Box sx={{ width: "100%", wordWrap: "break-word" }}>{title}</Box>
      </DialogTitle>
    ) : variant === "left" ? (
      <DialogTitle
        ref={ref}
        display="flex"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Box
          justifyContent="left"
          sx={{ width: "calc(100% - 40px)", wordWrap: "break-word" }}
        >
          {title}
        </Box>
        <Box
          display="flex"
          height="40px"
          alignItems="center"
          gap={1}
          marginBottom="auto"
        >
        </Box>
      </DialogTitle>
    ) : (
      <DialogTitle ref={ref} sx={{ paddingTop: 5, paddingBottom: 0 }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            {title}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: -1,
            paddingY: 3,
          }}
        >
          <Divider variant="gradient" sx={{ width: "104px" }} />
        </Box>
      </DialogTitle>
    );
  },
);
StandardDialogTitle.displayName = "StandardDialogTitle";

export default StandardDialogTitle;
